import {AfterViewInit, Component, Input, OnInit, QueryList, ViewChildren, ViewEncapsulation} from '@angular/core';
import {StatisticsTypesList} from '../../../../../statistics/enums/statistics.constants';
import {StatisticsTypes} from '../../../../../statistics/enums/statistics-types.enum';
import {StatisticsApiService} from '../../../../../services/api/statistics/statistics-api.service';
import {HighchartComponent} from '../../../../../utils/highchart/highchart.component';
import {ReportIdentifier} from '../../../../../statistics/enums/report-identifier.enum';
import {DateType} from '../../../../../statistics/enums/date-type.enum';
import {DateTimeUnitTypes} from '../../../../../statistics/enums/date-time-unit-types.enum';
import {ReportFilterType} from '../../../../../statistics/enums/report-filter-type.enum';
import {ChartParentType} from '../../../../../statistics/enums/chart-parent-type.enum';
import {ChartType} from '../../../../../utils/highchart/chart-type';
import {ChartDialogComponent} from '../../../../../dialogs/chart-dialog/chart-dialog.component';
import {AcDialogService} from 'ac-infra';

@Component({
  selector: 'map-summary-graphs',
  templateUrl: './map-summary-graphs.component.html',
  styleUrls: ['./map-summary-graphs.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class MapSummaryGraphsComponent implements OnInit, AfterViewInit {

  constructor(private statisticsApi: StatisticsApiService,
              private acDialogService: AcDialogService) {
  }

  @Input() set isActive(isActive: boolean) {
    if (isActive) {
      this.getChartsData();
    }
  }

  parameters: any;
  chartParentType: any;
  chartType: any;
  chartIsStack: any;
  routingAttemptsStatistics: any;
  unsuccessfulRoutesStatistics: any;
  callsStatistics: any;
  routingAttemptsChartOptions: any;
  unsuccessfulRoutesChartOptions: any;
  callsChartOptions: any;


  routingAttemptsChart: HighchartComponent;
  unsuccessfulRoutesChart: HighchartComponent;
  callsChart: HighchartComponent;

  @ViewChildren(HighchartComponent)
  charts: QueryList<HighchartComponent>;

  ngAfterViewInit(): void {
    const chartArray = this.charts.toArray();
    this.routingAttemptsChart = chartArray[0];
    this.unsuccessfulRoutesChart = chartArray[1];
    this.callsChart = chartArray[2];
  }

  ngOnInit(): void {
    this.parameters = {
      reportIdentifier: ReportIdentifier.armOverTime,
      dateType: DateType.RELATIVE,
      relativeTimeUnit: DateTimeUnitTypes.HOUR,
      relativeTimeUnitValue: 3,
      availableFilters: [ReportFilterType.DATE, ReportFilterType.MULTIPLE_STATISTICS],
      multipleStatistics: [
        StatisticsTypes.ROUTING_ATTEMPTS,
        StatisticsTypes.UNSUCCESSFUL_ROUTES,
        StatisticsTypes.ALTERNATIVE_ATTEMPTS,
        StatisticsTypes.DESTINATION_NOT_ROUTABLE,
        StatisticsTypes.DESTINATION_CALL,
        StatisticsTypes.TRANSIENT_CALL
      ]
    };

    this.chartParentType = ChartParentType.LINE;
    this.chartType = ChartType[ChartParentType.LINE].type;
    this.chartIsStack = ChartType[ChartParentType.LINE].stack;

    this.routingAttemptsStatistics = this.getRoutingAttemptsStatisticsNames();
    this.unsuccessfulRoutesStatistics = this.getUnsuccessfulRoutesStatisticsNames();
    this.callsStatistics = this.getCallsStatisticsNames();

    this.routingAttemptsChartOptions = {
      parentType: this.chartParentType,
      type: this.chartType,
      stacked: this.chartIsStack,
      series: [],
      title: {
        text: 'Routing attempts per 5 minutes',
        fontSize: '12px'
      },
      subTitle: '',
      startDate: undefined,
      interval: 0,
      animation: true,
      exporting: false
    };

    this.unsuccessfulRoutesChartOptions = {
      parentType: this.chartParentType,
      type: this.chartType,
      stacked: this.chartIsStack,
      series: [],
      title: {
        text: 'Unsuccessful Routes Per 5 Minutes',
        fontSize: '12px'
      },
      subTitle: '',
      startDate: undefined,
      interval: 0,
      animation: true,
      exporting: false
    };

    this.callsChartOptions = {
      parentType: this.chartParentType,
      type: this.chartType,
      stacked: this.chartIsStack,
      series: [],
      title: {
        text: 'Calls Per 5 Minutes',
        fontSize: '12px'
      },
      subTitle: '',
      startDate: undefined,
      interval: 0,
      animation: true,
      exporting: false
    };

    this.getChartsData();

    /*this.sharedEventService.on(this, 'nothingSelectedStatisticsRefresh', (event) => {
      this.getChartsData();
    });*/

  }

  openRoutingAttemptsChartDialog(): void {
    this.acDialogService.open(ChartDialogComponent, {
      dialogData: this.routingAttemptsChartOptions
    });
  }

  openUnsuccessfulRoutesChartDialog(): void {
    this.acDialogService.open(ChartDialogComponent, {
      dialogData: this.unsuccessfulRoutesChartOptions
    });
  }

  openCallsChartDialog(): void {
    this.acDialogService.open(ChartDialogComponent, {
      dialogData: this.callsChartOptions
    });
  }

  private getChartsData(): void {
    this.statisticsApi.getReportForChart(this.parameters)
      .then((reports) => {
        this.setRoutingAttemptsReport(reports);
        this.setUnsuccessfulRoutesReport(reports);
        this.setCallsReport(reports);
      })
      .catch(() => {
      });
  }

  private setRoutingAttemptsReport(value): void {
    const series = value.series.filter((element) => {
      return this.routingAttemptsStatistics.indexOf(element.name) !== -1;
    });

    this.routingAttemptsChartOptions.series = series;
    this.routingAttemptsChartOptions.startDate = value.startDate;
    this.routingAttemptsChartOptions.interval = value.interval;
    this.routingAttemptsChart.setOptions(this.routingAttemptsChartOptions);
  }

  private setUnsuccessfulRoutesReport(value): void {
    const series = value.series.filter((element) => {
      return this.unsuccessfulRoutesStatistics.indexOf(element.name) !== -1;
    });

    this.unsuccessfulRoutesChartOptions.series = series;
    this.unsuccessfulRoutesChartOptions.startDate = value.startDate;
    this.unsuccessfulRoutesChartOptions.interval = value.interval;
    this.unsuccessfulRoutesChart.setOptions(this.unsuccessfulRoutesChartOptions);
  }

  private setCallsReport(value): any {
    const series = value.series.filter((element) => {
      return this.callsStatistics.indexOf(element.name) !== -1;
    });

    this.callsChartOptions.series = series;
    this.callsChartOptions.startDate = value.startDate;
    this.callsChartOptions.interval = value.interval;
    this.callsChart.setOptions(this.callsChartOptions);
  }

  private getRoutingAttemptsStatisticsNames(): any {
    return StatisticsTypesList.filter((element) => {
      return element.value === StatisticsTypes.ROUTING_ATTEMPTS;
    }).map((element) => {
      return element.name;
    });
  }

  private getUnsuccessfulRoutesStatisticsNames(): any {
    return StatisticsTypesList.filter((element) => {
      return element.value === StatisticsTypes.UNSUCCESSFUL_ROUTES ||
        element.value === StatisticsTypes.ALTERNATIVE_ATTEMPTS ||
        element.value === StatisticsTypes.DESTINATION_NOT_ROUTABLE;
    }).map((element) => {
      return element.name;
    });
  }

  private getCallsStatisticsNames(): any {
    return StatisticsTypesList.filter((element) => {
      return element.value === StatisticsTypes.DESTINATION_CALL ||
        element.value === StatisticsTypes.TRANSIENT_CALL;
    }).map((element) => {
      return element.name;
    });
  }
}
